import React from 'react'
import UserLayout from '../../layouts/UserLayout'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Button, Divider, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'
import { mainGreen, mainRed } from '../../utils/color'
// import SaveAltOutlinedIcon from "@mui/icons-material/SaveAltOutlined";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import { api } from '../../utils/api'
import { handleError } from '../../utils/error'
import { currentUserActions } from '../../redux/store'
import { getFromStorage } from '../../utils/storage'
import { generateCode } from '../../utils/helper'

export default function StockBillDetailByStore() {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const token = getFromStorage('current-user')?.accessToken
	const { billDetail } = useSelector((state) => state.billDetail)
	// const [loader, setLoader] = useState(false);
	const { storeId } = useParams()
	const billCode = generateCode()

	const saveBill = async () => {
		try {
			const checkBill = billDetail?.detail
			if (!checkBill) {
				alert('Chưa có đơn hàng trong hóa đơn')
				return
			}
			const res = await axios({
				url: api.BILLING_ORDER,
				headers: {
					Authorization: `Bearer ${token}`,
				},
				method: 'PUT',
				data: { detail: billDetail?.detail, billCode },
				withCredentials: true,
			})
			if (res.data.message) {
				alert(res.data.message)
			}
			navigate(`/admin/bill/${storeId}`)
			// const capture = document.querySelector(".actual-receipt");
			// setLoader(true);
			// html2canvas(capture, { scale: 5 }).then((canvas) => {
			//   const imgData = canvas.toDataURL("image/jpeg");
			//   const doc = new jsPDF({
			//     orientation: "portrait",
			//     unit: "px",
			//     format: "a4",
			//   });
			//   const componentWidth = doc.internal.pageSize.getWidth();
			//   const componentHeight = (canvas.height * componentWidth) / canvas.width;
			//   doc.addImage(imgData, "JPEG", 0, 0, componentWidth, componentHeight);
			//   setLoader(false);
			//   doc.save("Hoa-don-NNQQ.pdf");
			// });
		} catch (error) {
			handleError(error)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	return (
		<UserLayout>
			<Box
				sx={{
					maxWidth: 700,
					marginX: 'auto',
					pb: 4,
					background: '#fff',
				}}>
				<Box className='actual-receipt' sx={{ px: 1, pt: 4 }}>
					<Typography
						sx={{
							fontSize: '18px',
							fontWeight: 'bold',
							textAlign: 'center',
							letterSpacing: '2px',
							mb: 2,
						}}>
						HÓA ĐƠN BÁN HÀNG <br />
						CHI NHÁNH {billDetail?.store.name}
					</Typography>
					<Box>
						<Typography>Mã HĐ: {billCode}</Typography>
						<Typography>
							Ngày xuất:{' '}
							{new Date().toLocaleDateString([], {
								day: '2-digit',
								month: '2-digit',
								year: '2-digit',
							})}
						</Typography>
						<Table sx={{ mt: 2 }}>
							<TableHead>
								<TableRow>
									<TableCell sx={{ px: 0, py: 1, borderRight: '1px solid #000' }}>STT</TableCell>
									<TableCell sx={{ px: 0, py: 1, borderRight: '1px solid #000' }}>Ngày giao</TableCell>
									<TableCell sx={{ px: 0, py: 1, borderRight: '1px solid #000' }}>Số kg</TableCell>
									<TableCell sx={{ px: 0, py: 1, borderRight: '1px solid #000' }}>Thực tính</TableCell>
									<TableCell sx={{ px: 0, py: 1, borderRight: '1px solid #000' }}>Đơn giá</TableCell>
									<TableCell sx={{ px: 0, py: 1 }}>Thành tiền</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{billDetail?.detail.map((item, index) => {
									return (
										<TableRow key={index}>
											<TableCell sx={{ p: 1, borderRight: '1px solid #000' }}>{index + 1}</TableCell>
											<TableCell sx={{ p: 1, borderRight: '1px solid #000' }}>{item.timeStamp.slice(0, 8)}</TableCell>
											<TableCell sx={{ p: 1, borderRight: '1px solid #000' }}>
												{item.quantity?.toLocaleString()}
											</TableCell>
											<TableCell sx={{ p: 1, borderRight: '1px solid #000' }}>
												{Math.round(item.quantity * 0.98)?.toLocaleString()}
											</TableCell>
											<TableCell sx={{ p: 1, borderRight: '1px solid #000' }}>
												{item.unitPrice?.toLocaleString()}
											</TableCell>
											<TableCell sx={{ p: 1 }}>
												{(Math.round(item.quantity * 0.98) * item.unitPrice)?.toLocaleString()}
											</TableCell>
										</TableRow>
									)
								})}
							</TableBody>
						</Table>
						<Divider sx={{ mt: 2, mb: 2 }} />
						<Box display='flex' justifyContent='space-between' sx={{ mb: 1 }}>
							<Typography sx={{ fontWeight: '500' }}>Tổng số kg:</Typography>
							<Typography sx={{ fontWeight: '500' }}>
								{billDetail?.detail.reduce((sum, item) => (sum += item.quantity), 0)?.toLocaleString()} (Thực tính:{' '}
								{billDetail?.detail
									.reduce((sum, item) => (sum += Math.round(item.quantity * 0.98)), 0)
									?.toLocaleString()}
								)
							</Typography>
						</Box>
						<Box display='flex' justifyContent='space-between' sx={{ mb: 4 }}>
							<Typography sx={{ fontWeight: '500' }}>Tổng tiền:</Typography>
							<Typography sx={{ fontWeight: '500' }}>
								{billDetail?.detail
									.reduce((sum, item) => (sum += Math.round(item.quantity * 0.98) * item.unitPrice), 0)
									?.toLocaleString()}{' '}
								đ
							</Typography>
						</Box>
					</Box>
				</Box>
				<Box display='flex' justifyContent='space-between' alignItems='flex-end' sx={{ px: 1 }}>
					<Button
						sx={{ color: mainRed }}
						size='small'
						onClick={() => {
							navigate(`/admin/bill/${storeId}`)
						}}>
						Quay lại
					</Button>
					<Button
						size='small'
						sx={{ background: mainGreen, '&:hover': { background: mainGreen } }}
						onClick={saveBill}
						// disabled={!(loader === false)}
						variant='contained'>
						{/* <SaveAltOutlinedIcon sx={{ fontSize: "22px", mt: "-6px", mr: 1 }} />
            {loader ? "Đang tải" : "Lưu và tải PDF"} */}
						Lưu hóa đơn
					</Button>
				</Box>
			</Box>
		</UserLayout>
	)
}
